module.exports = __webpack_public_path__ + "static/media/Address-confirm-arrow.6f01acda.svg";